import { Component, OnInit } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
